import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher, Result } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { ProfileRepository } from "../domain/ProfileRepository";

export class ApiProfile implements ProfileRepository{
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor(){
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }

    async userHasSomeFacturaEService(args: object): Promise<any> {
        try{
            const result = await this.query_dispatcher.dispatch('user.has.some.facturae.service', args);
            return result
        }catch(error){
            console.log(error)
            return true
        }
    }
}

export class ApiProfileMemory implements ProfileRepository{
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor(){
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }

    async userHasSomeFacturaEService(args: object): Promise<any> {
        return true
    }
}